import React, { useEffect, useState } from "react";
import { Select } from "antd";
import ExamCard from "../exam-card/exam-card";
import styles from "./report-card-sidebar.module.css";
import CustomSelect from "../../../../../../../../common/input/custom-select/custom-select";
import EmptyLoader from "../../../../../../../../components/emptyloader/emptyloader";

const { Option } = Select;

const ReportCardSidebar = ({
  filteredExams,
  onExamSelect,
  sort,
  setSort,
  selectedYear,
  termList,
  yearList,
  changeSelectedYear,
  onPopupScroll,
  loading,
  studentID,
  isEcdStudent,
}) => {
  const [activeId, setActiveId] = useState(null);

  useEffect(() => {
    setActiveId(null);
  }, [studentID]);

  const handleSelect = (exam) => {
    setActiveId(exam.id);
    onExamSelect(exam);
  };

  return (
    <div className={styles["sidebar-container"]}>
      <div className={styles["sidebar-header"]}>
        <h3>My Exams</h3>
        <div className={styles["filter-conatiner"]}>
          <CustomSelect
            placeholder="--Select--"
            value={selectedYear}
            onChange={changeSelectedYear}
            onPopupScroll={onPopupScroll}
            style={{ width: "80px" }}
          >
            {yearList?.map((item, index) => (
              <Option key={item?.id || index} value={item?.id}>
                {item?.name}
              </Option>
            ))}
          </CustomSelect>
          <CustomSelect
            placeholder="--Select--"
            value={sort}
            onChange={(value) => setSort(value)}
            style={{ width: "120px" }}
          >
            {termList?.map((option) => (
              <Option key={option.value} value={option.value}>
                {option.label}
              </Option>
            ))}
          </CustomSelect>
        </div>
      </div>
      
      {isEcdStudent ? (
        <div className={styles["ecd-message"]}>
          <div className={styles["ecd-icon"]}>📘</div>
          <div className={styles["ecd-title"]}>No Exams Available for ECD</div>
          <div className={styles["ecd-text"]}>
            This student is enrolled in the ECD program for the selected academic year.
          </div>
        </div>
      ) : (
        <EmptyLoader loading={loading} isDataAvailable={filteredExams?.length} />
      )}
      <div className={styles["exam-list"]}>
        {filteredExams?.map((exam) => (
          <ExamCard
            key={exam.id}
            exam={exam}
            active={activeId === exam.id}
            onClick={handleSelect}
          />
        ))}
      </div>
    </div>
  );
};

export default ReportCardSidebar;
